import { createSelector } from 'reselect';
import { alertsAndNotificationsSelectionsInitialState } from './AlertsAndNotificationsReducer';

export const getActivationCode = () => null;

export const getAlertsAndNotificationsSelections = (state) =>
  state.alertsAndNotificationsSelections ||
  alertsAndNotificationsSelectionsInitialState;

export const retrieveAlertsAndNotifications = (state) =>
  state.alertsAndNotifications || [];

export const getAlertsAndNotificationsEmail = (state) => {
  return state.alertsAndNotificationsEmail || '';
};

export const getAlertsAndNotificationsPhoneNumbers = (state) =>
  state.alertsAndNotificationsPhoneNumbers || [];

export const getIsActivatedForAlerts = (state) =>
  state.isActivatedForTextAlerts;

export const getMobileCarriers = (state) => state.mobileCarriers;

export const getHasTextMessageConsent = (state) => state.hasTextMessageConsent;

export const getHasOptedOutOfTextAlerts = (state) =>
  state.hasOptedOutOfTextAlerts;

export const getHasDeactivationReasonCode = (state) =>
  state.hasDeactivationReasonCode;

export const getIsEligibleForSMSSignUp = createSelector(
  getIsActivatedForAlerts,
  getHasTextMessageConsent,
  (isActivatedForTextAlerts, hasTextMessageConsent) => {
    return !hasTextMessageConsent || !isActivatedForTextAlerts;
  }
);
